import React, { useState, useEffect } from 'react';
import { collection, addDoc, getDocs } from 'firebase/firestore';
import { db } from '../../firebase'; 
import "./ContactUs.css";
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';

export const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [quoteDetails, setQuoteDetails] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    message: '',
    program: '', // New field for Program
    city: '',    // New field for City
  });

  const [quoteSubmitted, setQuoteSubmitted] = useState(false);
  const [quotes, setQuotes] = useState([]);
  const [uploading, setUploading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setQuoteDetails({ ...quoteDetails, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);
    try {
      const docRef = await addDoc(collection(db, 'quotes'), quoteDetails);
      console.log('Document written with ID: ', docRef.id);
      setQuoteSubmitted(true);
      setQuoteDetails({
        name: '',
        email: '',
        phoneNumber: '',
        message: '',
        program: '',
        city: '',
      });
      toast.success("Message Submitted Successfully!");
    } catch (error) {
      console.error('Error adding document: ', error);
      toast.error("Something went wrong. Please try again.");
    }
    window.location.reload();
  };

  const getQuotesFromFirebase = async () => {
    const querySnapshot = await getDocs(collection(db, 'quotes'));
    const quotesData = [];
    querySnapshot.forEach((doc) => {
      quotesData.push({ id: doc.id, ...doc.data() });
    });
    setQuotes(quotesData);
  };

  // Fetch quotes on component mount
  useEffect(() => {
    getQuotesFromFirebase();
  }, []);

  return (
    <div className='contact-page'>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Contact Us</title>
        <meta name="description" content="We're Always Eager to Hear From You!" />
      </Helmet>

      <div className='contact-content'>
        <div className='contact-details'>
          <h2>The Golden Palace <br />A Luxuries Marriage Garden and Resort</h2>
          <b>Address</b>
          <p>Near Rahman gate, Pushkar Highway, Didwana (341303), Rajasthan, India</p>
          <b>Email</b>
          <p>thegoldenpalacedidwana@gmail.com</p>
          <b>Phone</b>
          <p>+91 9001710160, +91 8058753950, +91 9414548063</p>
        </div>

        <div className='contact-form'>
          <h2>Get In Touch</h2>
          <p>Reserve Your Perfect Venue Today, Celebrate Tomorrow!</p>
          <form onSubmit={handleSubmit}>
            <label>Name:</label>
            <input
              className='contact-input'
              type='text'
              name='name'
              value={quoteDetails.name}
              onChange={handleChange}
              required
            />
            <label>Email:</label>
            <input
              className='contact-input'
              type='email'
              name='email'
              value={quoteDetails.email}
              onChange={handleChange}
              required
            />
            <label>Phone Number:</label>
            <input
              className='contact-input'
              type='text'
              name='phoneNumber'
              value={quoteDetails.phoneNumber}
              onChange={handleChange}
              required
            />
            <label>Select Program:</label>
            <select
              className='contact-input'
              name='program'
              value={quoteDetails.program}
              onChange={handleChange}
              required
            >
              <option value="">-- Select Program --</option>
              <option value="Marriage">Marriage</option>
              <option value="Accommodation">Accommodation Rooms</option>
              <option value="Relaxation">Swimming Pool</option>
              <option value="Birthday">Birthday celebration</option>
              <option value="Parties">Parties</option>
              
            </select>
            <label>City:</label>
            <input
              className='contact-input'
              type='text'
              name='city'
              value={quoteDetails.city}
              onChange={handleChange}
              required
            />
            <label>Message:</label>
            <textarea
              className='contact-input'
              name='message'
              value={quoteDetails.message}
              onChange={handleChange}
              required
            ></textarea>
            <button className='contact-button' type='submit'>
              {uploading ? "Submitting..." : "Send Now"}
            </button>
          </form>
        </div>
      </div>

      <div className='contact-map'>
        <iframe
          width="100%"
          height="650px"
          loading="lazy"
          allowfullscreen
          src=
         "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3542.8442813440033!2d74.59300250978409!3d27.380578176272824!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396b6b0036afe3d1%3A0xc6b62f8e0fc10a0d!2sThe%20Golden%20Palace!5e0!3m2!1sen!2sin!4v1735887303016!5m2!1sen!2sin"
          className='contact-map-iframe'
        ></iframe>
      </div>
    </div>
  );
};
